import { Link } from 'react-router-dom';

const WhyNexus = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Why Nexus IT?</h1>
          <p>
            We are more than an IT vendor—we are a strategic partner that delivers measurable outcomes, resilient
            infrastructures, and exceptional support across the project lifecycle.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container split">
          <div className="text-block">
            <span className="badge">Key Advantages</span>
            <h2>Delivering Confidence Through Expertise</h2>
            <ul className="checklist">
              <li>Authorized partner with leading global IT manufacturers</li>
              <li>Customer-centric service model with tailored engagement plans</li>
              <li>Experienced team for government and large enterprise projects</li>
              <li>Competitive pricing powered by direct OEM partnerships</li>
              <li>End-to-end support covering supply, installation, training, and after-sales</li>
              <li>Commitment to confidentiality, compliance, and security best practices</li>
              <li>Nexus IT goes beyond basic IT—we deliver services that enable business outcomes</li>
            </ul>
          </div>
          <div className="stat-grid">
            <article className="stat-card">
              <h4>Strategic Alliances</h4>
              <p>Our partnerships ensure access to the latest technologies and enable rapid response to emerging needs.</p>
            </article>
            <article className="stat-card">
              <h4>Proven Frameworks</h4>
              <p>We follow structured methodologies across planning, readiness, implementation, testing, and handover.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Experience the Nexus IT Difference</h2>
              <p>Speak with our consultants to plan your next technology upgrade or transformation initiative.</p>
            </div>
            <Link className="btn btn-primary" to="/contact">
              Start the Conversation
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyNexus;
